import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective } from '@ngx-translate/core';
import { AutofocusDirective } from '../autofocus/autofocus.directive';

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  imports: [TranslateDirective, AutofocusDirective],
})
export class ConfirmDeleteDialogComponent {
  protected modal = inject(NgbActiveModal);

  @Input()
  public message!: string;
  @Input()
  public title!: string;
}
